import React from 'react'
import './searchParameters.css'
import { useSelector } from 'react-redux'

function SearchParameters({ onSearchTriggered, ownerList, artistList }) {
	const [selectedOwner, setSelectedOwner] = React.useState(null)
	const [selectedArtist, setSelectedArtist] = React.useState(null)
	const [title, setTitle] = React.useState('')

	const pex = useSelector((state) => state.user.value.pex)
	const read_owner = pex.read_owner || pex.read_owner_names
	const read_artist = pex.read_artist || pex.read_artist_names
	const noPermissionText = 'Keine Berechtigung'

	function onOwnerInput(e) {
		const index = parseInt(e.target.value)
		if (index === -1) {
			setSelectedOwner(null)
		} else {
			setSelectedOwner(ownerList[index])
		}
	}
	function onArtistInput(e) {
		const index = e.target.value
		if (index === -1) {
			setSelectedArtist(null)
		} else {
			setSelectedArtist(artistList[index])
		}
	}
	function onTitleInput(e) {
		const value = e.target.value
		setTitle(value)
	}

	//user requests search of artworks (form button)
	function onClickSearchButton() {
		const artistId = selectedArtist?.id
		const ownerId = selectedOwner?.id
		console.log(
			'search with data: artistId ' +
				artistId +
				' ownerId ' +
				ownerId +
				" title: '" +
				title +
				"'"
		)
		onSearchTriggered({ artistId, ownerId, title })
	}

	return (
		<div id='searchParameterContainer'>
			<form
				id='searchParameterForm'
				method='post'
				onSubmit={(e) => {
					e.preventDefault()
				}}
			>
				<div className='searchParameterField'>
					<label htmlFor='selectOwner'> Besitzer: </label>
					<select
						id='selectOwner'
						onInput={(e) => onOwnerInput(e)}
						disabled={!read_owner}
						style={{ color: read_owner ? 'inherit' : 'red' }}
					>
						{read_owner ? (
							<>
								<option value={-1}>-keine Auswahl-</option>
								{ownerList.map((e, index) => (
									<option key={index} value={index}>
										{e.lastname + ' ' + e.firstname + ' ' + ' [' + e.id + ']'}
									</option>
								))}
							</>
						) : (
							<option value={-1}>{noPermissionText}</option>
						)}
					</select>
				</div>

				<div className='searchParameterField'>
					<label htmlFor='selectArtist'> Künstler: </label>

					<select
						id='selectArtist'
						onInput={(e) => onArtistInput(e)}
						disabled={!read_artist}
						style={{ color: read_artist ? 'inherit' : 'red' }}
					>
						{read_artist ? (
							<>
								<option value={-1}>-keine Auswahl-</option>
								{artistList.map((e, index) => (
									<option key={index} value={index}>
										{e.lastname + ' ' + e.firstname + ' ' + ' [' + e.id + ']'}
									</option>
								))}
							</>
						) : (
							<>
								<option value={-1}>{noPermissionText}</option>
							</>
						)}
					</select>
				</div>

				<div className='searchParameterField'>
					<label htmlFor='selectTitle'>
						Begriffe aus Bildtitel:
						<span className='searchParameterFieldDescription'>
							(Begriffe durch Leerzeichen trennen)
						</span>
					</label>

					<input
						id='selectTitle'
						type='text'
						onInput={(e) => onTitleInput(e)}
						size='20'
					/>
				</div>

				<div className='searchParameterField'>
					<div id='submitButtonContainer'>
						<button
							id='submitButton'
							onClick={() => onClickSearchButton()}
							className='defaultButton'
						>
							Suche starten
						</button>
					</div>
				</div>
			</form>
		</div>
	)
}

export default SearchParameters
